(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5450],{

/***/ 53002:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cost/[segment]/[location]",
      function () {
        return __webpack_require__(90523);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 5823:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ GAMAds; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _care_htl_bid__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80976);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86886);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(80822);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42660);
/* harmony import */ var _hooks_useResponsive__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19147);







var GAMAds = function(param) {
    var slotName = param.slotName, slotProps = param.slotProps;
    var ref = (0,_hooks_useResponsive__WEBPACK_IMPORTED_MODULE_3__/* .useResponsive */ .F)(), isSmallViewport = ref.isSmallViewport, isMediumViewport = ref.isMediumViewport;
    var dimensions = function() {
        if (isSmallViewport) {
            return {
                width: 320,
                height: 50
            };
        }
        if (isMediumViewport) {
            return {
                width: 468,
                height: 50
            };
        }
        if (slotName === _constants__WEBPACK_IMPORTED_MODULE_2__/* .HTL_SLOTS.SEO_DIRECTORY_RR_1 */ .YQ.SEO_DIRECTORY_RR_1) {
            return {
                width: 300,
                height: 250
            };
        }
        if (slotName === _constants__WEBPACK_IMPORTED_MODULE_2__/* .HTL_SLOTS.SEO_PROV_PROFILE_RR_1 */ .YQ.SEO_PROV_PROFILE_RR_1) {
            return {
                width: 300,
                height: 600
            };
        }
        return {
            width: 728,
            height: 90
        };
    }();
    var width = dimensions.width, height = dimensions.height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
        className: slotName,
        item: true,
        xs: 12,
        display: "flex",
        justifyContent: "center",
        pt: {
            xs: 1,
            sm: 5
        },
        pb: {
            xs: 4,
            sm: 8
        },
        sx: {
            "&.seo-prov-profile-inline-1, &.seo-prov-profile-inline-2": {
                pt: {
                    xs: 4,
                    md: 16
                },
                pb: 4
            },
            "&.seo-prov-profile-inline-2": {
                pt: {
                    xs: 4
                },
                pb: 4
            }
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
            width: "".concat(width, "px"),
            height: "".concat(height, "px")
        }, slotProps), {
            overflow: "visible",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_care_htl_bid__WEBPACK_IMPORTED_MODULE_1__/* .HTLBIDSlot */ .qF, {
                slotName: slotName
            })
        }))
    });
};



/***/ }),

/***/ 32778:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ useLDClientFlags; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(828);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42660);
/* harmony import */ var _components_contexts_FeatureFlagsContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63880);



var useLDClientFlags = function() {
    var featureFlags = (0,_components_contexts_FeatureFlagsContext__WEBPACK_IMPORTED_MODULE_1__/* .useFeatureFlags */ .g)();
    var activeFlags = {};
    return Object.entries(_constants__WEBPACK_IMPORTED_MODULE_0__/* .UI_FEATURE_FLAGS */ .WV).reduce(function(acc, flag) {
        var ref;
        var _flag = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(flag, 2), flagName = _flag[0], flagDetails = _flag[1];
        var currentFlag = featureFlags === null || featureFlags === void 0 ? void 0 : (ref = featureFlags.flags) === null || ref === void 0 ? void 0 : ref[flagDetails.id];
        acc[flagName] = currentFlag;
        return acc;
    }, activeFlags);
};


/***/ }),

/***/ 19147:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ useResponsive; }
/* harmony export */ });
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61730);

function useResponsive() {
    var isSmallViewport = (0,_mui_material__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(theme) {
        return theme.breakpoints.down("sm");
    }); // Mobile Devices
    var isMediumViewport = (0,_mui_material__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(theme) {
        return theme.breakpoints.between("sm", "lg");
    }); // Large Mobile and Tablets
    var isLargeViewport = (0,_mui_material__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(theme) {
        return theme.breakpoints.up("lg");
    }); // Small and Large Desktops
    return {
        isSmallViewport: isSmallViewport,
        isMediumViewport: isMediumViewport,
        isLargeViewport: isLargeViewport
    };
}



/***/ }),

/***/ 90523:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* reexport */ costGuide_CostGuidePage; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@care/navigation/dist/components/CoreGlobalFooter/CoreGlobalFooter.js + 8 modules
var CoreGlobalFooter = __webpack_require__(69388);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(86886);
// EXTERNAL MODULE: ./node_modules/@mui/material/Container/Container.js + 1 modules
var Container = __webpack_require__(65582);
// EXTERNAL MODULE: ./src/components/SeoGlobalNavbar.tsx
var SeoGlobalNavbar = __webpack_require__(8410);
// EXTERNAL MODULE: ./src/components/HowItWorks.tsx
var HowItWorks = __webpack_require__(65477);
// EXTERNAL MODULE: ./src/utils/generateEnrollmentUrl.ts + 1 modules
var generateEnrollmentUrl = __webpack_require__(85715);
// EXTERNAL MODULE: ./src/utils/createRelativeImageURL.ts
var createRelativeImageURL = __webpack_require__(83174);
// EXTERNAL MODULE: ./src/lib/analyticsHelper.tsx
var analyticsHelper = __webpack_require__(883);
// EXTERNAL MODULE: ./src/constants.ts
var constants = __webpack_require__(42660);
// EXTERNAL MODULE: ./src/components/PageMeta.tsx
var PageMeta = __webpack_require__(96301);
// EXTERNAL MODULE: ./src/utils/dateMonthYearFormat.ts
var dateMonthYearFormat = __webpack_require__(42182);
// EXTERNAL MODULE: ./src/components/hooks/useLDClientFlags.tsx
var useLDClientFlags = __webpack_require__(32778);
// EXTERNAL MODULE: ./src/components/GAMAds.tsx
var GAMAds = __webpack_require__(5823);
// EXTERNAL MODULE: ./node_modules/@care/react-icons/dist/Icon24UtilityChevron.js
var Icon24UtilityChevron = __webpack_require__(68720);
// EXTERNAL MODULE: ./node_modules/@mui/material/Link/Link.js + 2 modules
var Link = __webpack_require__(23795);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(80822);
// EXTERNAL MODULE: ./node_modules/@mui/material/Accordion/Accordion.js + 3 modules
var Accordion = __webpack_require__(82280);
// EXTERNAL MODULE: ./node_modules/@mui/material/AccordionSummary/AccordionSummary.js + 1 modules
var AccordionSummary = __webpack_require__(38895);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/material/AccordionDetails/AccordionDetails.js + 1 modules
var AccordionDetails = __webpack_require__(22797);
// EXTERNAL MODULE: ./node_modules/he/he.js
var he = __webpack_require__(86492);
var he_default = /*#__PURE__*/__webpack_require__.n(he);
// EXTERNAL MODULE: ./node_modules/sanitize-html/index.js
var sanitize_html = __webpack_require__(91036);
var sanitize_html_default = /*#__PURE__*/__webpack_require__.n(sanitize_html);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(61730);
// EXTERNAL MODULE: ./src/__generated__/globalTypes.ts
var globalTypes = __webpack_require__(79967);
;// CONCATENATED MODULE: ./src/components/pages/costGuide/CostGuideLinkList.tsx







var CostGuideLinkList = function(param) {
    var costGuideLinkList = param.costGuideLinkList, city = param.city, stateCode = param.stateCode;
    var isMobileOrSmaller = (0,useMediaQuery/* default */.Z)(function(theme) {
        return theme.breakpoints.down("md");
    });
    var seoLinks = costGuideLinkList.filter(function(costGuideSeoLink) {
        return costGuideSeoLink.linkList.length > 0;
    });
    var links = function(linkList) {
        return linkList.map(function(link, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                variant: "link2",
                href: link.url,
                sx: {
                    cursor: "pointer",
                    lineHeight: "30px",
                    ":hover": {
                        textDecoration: "none"
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML: {
                        __html: sanitize_html_default()(he_default().decode(link.content))
                    }
                })
            }, "".concat(link.content, "-").concat(index + 1));
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
        maxWidth: "lg",
        sx: {
            mt: {
                xs: 5,
                md: 8
            },
            mb: {
                xs: 4.5,
                md: 8
            }
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
            item: true,
            xs: 12,
            children: seoLinks.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                children: seoLinks.map(function(costGuideSeoLink) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        display: "flex",
                        flexDirection: "column",
                        width: "100%",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Accordion/* default */.Z, {
                            defaultExpanded: !isMobileOrSmaller,
                            elevation: 0,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionSummary/* default */.Z, {
                                    sx: function(theme) {
                                        return {
                                            width: "fit-content",
                                            padding: 0,
                                            "& .MuiButtonBase-root": {
                                                marginTop: theme.spacing(1)
                                            }
                                        };
                                    },
                                    expandIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon24UtilityChevron/* default */.Z, {
                                        color: "text.secondary"
                                    }),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "h4",
                                        color: "text.secondary",
                                        children: costGuideSeoLink.id === globalTypes/* InternalLinkSectionId.RELATED_SERVICES */.$z.RELATED_SERVICES ? "".concat(costGuideSeoLink.title, " in ").concat(city, ", ").concat(stateCode) : costGuideSeoLink.title
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionDetails/* default */.Z, {
                                    sx: {
                                        p: 0
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                        display: {
                                            sm: "flex"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                display: "flex",
                                                flexDirection: "column",
                                                width: "100%",
                                                children: links(costGuideSeoLink.linkList).slice(0, 5)
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                display: "flex",
                                                flexDirection: "column",
                                                width: "100%",
                                                children: links(costGuideSeoLink.linkList).slice(5, 10)
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                display: "flex",
                                                flexDirection: "column",
                                                width: "100%",
                                                children: links(costGuideSeoLink.linkList).slice(10, 15)
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                display: "flex",
                                                flexDirection: "column",
                                                width: "100%",
                                                children: links(costGuideSeoLink.linkList).slice(15, 20)
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    }, costGuideSeoLink.title);
                })
            })
        })
    });
};
/* harmony default export */ var costGuide_CostGuideLinkList = (CostGuideLinkList);

// EXTERNAL MODULE: ./src/components/pages/costGuide/CostGuideSlimSearch.tsx + 2 modules
var CostGuideSlimSearch = __webpack_require__(91144);
// EXTERNAL MODULE: ./node_modules/@care/react-component-lib/dist/components/Card/Card.js
var Card = __webpack_require__(37088);
// EXTERNAL MODULE: ./node_modules/@mui/material/TableCell/TableCell.js + 1 modules
var TableCell = __webpack_require__(53252);
// EXTERNAL MODULE: ./node_modules/@mui/material/TableRow/TableRow.js + 1 modules
var TableRow = __webpack_require__(68509);
// EXTERNAL MODULE: ./node_modules/@mui/material/Table/Table.js + 1 modules
var Table = __webpack_require__(7906);
// EXTERNAL MODULE: ./node_modules/@mui/material/TableHead/TableHead.js + 1 modules
var TableHead = __webpack_require__(53184);
// EXTERNAL MODULE: ./node_modules/@mui/material/TableBody/TableBody.js + 1 modules
var TableBody = __webpack_require__(295);
;// CONCATENATED MODULE: ./src/components/pages/costGuide/ComparisonChart.tsx


var ComparisonChart = function(param) {
    var chartData = param.chartData;
    var barGraphMaxHeightPx = 100;
    var getMaximumHourlyRate = function(data) {
        return data.reduce(function(currentRate, currentData) {
            var ref, ref1, ref2, ref3;
            var maxHourlyRate = ((ref = currentData.rates) === null || ref === void 0 ? void 0 : (ref1 = ref.maximumRate) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.maximumHourlyRate) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.rate) === null || ref3 === void 0 ? void 0 : ref3.amount) ? parseFloat(currentData.rates.maximumRate.maximumHourlyRate.rate.amount) : null;
            if (maxHourlyRate && maxHourlyRate > currentRate) {
                return maxHourlyRate;
            }
            return currentRate;
        }, 0).toFixed(2);
    };
    var maximumHourlyRate = getMaximumHourlyRate(chartData);
    var barHeightPx = function(hourlyRate, maxHourlyRate) {
        return "".concat(Math.round(barGraphMaxHeightPx * parseFloat(hourlyRate) / parseFloat(maxHourlyRate)), "px");
    };
    var getLocation = function(locationObject) {
        if (!locationObject) return "US";
        var city = locationObject.city, state = locationObject.state;
        if (city && (state === null || state === void 0 ? void 0 : state.stateCode)) {
            return "".concat(city, ", ").concat(state.stateCode);
        }
        return state.name;
    };
    var barGraph = function() {
        return chartData.map(function(locationData) {
            var ref, ref1, ref2, ref3, ref4, ref5;
            var rates = locationData.rates;
            var location = getLocation(locationData.location);
            var avgHourlyRate = (rates === null || rates === void 0 ? void 0 : (ref = rates.averageRate) === null || ref === void 0 ? void 0 : (ref1 = ref.averageHourlyRate) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.rate) === null || ref2 === void 0 ? void 0 : ref2.amount) ? parseFloat(rates.averageRate.averageHourlyRate.rate.amount).toFixed(2) : null;
            var maxHourlyRate = (rates === null || rates === void 0 ? void 0 : (ref3 = rates.maximumRate) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.maximumHourlyRate) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.rate) === null || ref5 === void 0 ? void 0 : ref5.amount) ? parseFloat(rates.maximumRate.maximumHourlyRate.rate.amount).toFixed(2) : null;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                pr: 2,
                children: avgHourlyRate && maxHourlyRate && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                            display: "flex",
                            alignItems: "flex-end",
                            pb: 1,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                    display: "flex",
                                    flexDirection: "column",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                            align: "center",
                                            variant: "tag",
                                            children: [
                                                "$",
                                                avgHourlyRate
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                            width: "44px",
                                            height: barHeightPx(avgHourlyRate, maximumHourlyRate),
                                            sx: function(theme) {
                                                return {
                                                    backgroundColor: theme.palette.care.blue[500]
                                                };
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                    display: "flex",
                                    flexDirection: "column",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                            align: "center",
                                            variant: "tag",
                                            children: [
                                                "$",
                                                maxHourlyRate
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                            width: "44px",
                                            height: barHeightPx(maxHourlyRate, maximumHourlyRate),
                                            sx: function(theme) {
                                                return {
                                                    backgroundColor: theme.palette.care.navy[600]
                                                };
                                            }
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "body3",
                            align: "center",
                            children: location
                        })
                    ]
                })
            }, location);
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                display: "flex",
                mb: 2,
                alignItems: "flex-end",
                sx: {
                    "& div:last-child": {
                        paddingRight: 0
                    }
                },
                children: barGraph()
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                display: "flex",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        display: "flex",
                        alignItems: "center",
                        mr: 5,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                width: "15px",
                                height: "15px",
                                mr: 1,
                                sx: function(theme) {
                                    return {
                                        backgroundColor: theme.palette.care.blue[500]
                                    };
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "info1",
                                children: "Starting rate (avg)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        display: "flex",
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                width: "15px",
                                height: "15px",
                                mr: 1,
                                sx: function(theme) {
                                    return {
                                        backgroundColor: theme.palette.care.navy[600]
                                    };
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "info1",
                                children: "Max rate (avg)"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var costGuide_ComparisonChart = (ComparisonChart);

;// CONCATENATED MODULE: ./src/components/pages/costGuide/ComparisonTable.tsx






var ComparisonTable = function(param) {
    var tableData = param.tableData, currentCity = param.currentCity, currentStateCode = param.currentStateCode, serviceNameLowercase = param.serviceNameLowercase, serviceNamePluralLowercase = param.serviceNamePluralLowercase, _isGeographicComparison = param.isGeographicComparison, isGeographicComparison = _isGeographicComparison === void 0 ? false : _isGeographicComparison, _isMostAffordableCities = param.isMostAffordableCities, isMostAffordableCities = _isMostAffordableCities === void 0 ? false : _isMostAffordableCities;
    var isMobileOrSmaller = (0,useMediaQuery/* default */.Z)(function(theme) {
        return theme.breakpoints.down("md");
    });
    var locationHeader = isGeographicComparison ? "Location" : "City";
    var avgHourlyRateHeader = "Starting rate (avg)";
    var maxHourlyRateHeader = "Max rate (avg)";
    var numOfDecimalPlaces = 2;
    var stateFullName = currentStateCode ? constants/* mapStateCodeToFullName */.Q5[currentStateCode] : null;
    var comparisonChartClassName = function() {
        if (isGeographicComparison) {
            return "geographic";
        }
        if (isMostAffordableCities) {
            return "most-affordable";
        }
        return "most-expensive";
    }();
    var roundRate = function(amount) {
        var numOfDecimals = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
        if (typeof amount === "string") {
            return parseFloat(amount).toFixed(numOfDecimals);
        }
        return amount.toFixed(numOfDecimals);
    };
    var getStateGeographicData = function() {
        if (!tableData || tableData.__typename !== "CostGuideGeographicRateComparison") return null;
        var state = tableData.hourlyRateComparisons.state;
        return {
            stateHourlyRate: roundRate(state.comparison.hourlyRate.amount, numOfDecimalPlaces),
            statePercentage: roundRate(state.comparison.percentage.value),
            stateRelativePosition: constants/* mapCostGuidePercentageRelativePositionToString */.pQ[state.comparison.percentage.relativePosition]
        };
    };
    var getNationalGeographicData = function() {
        if (!tableData || tableData.__typename !== "CostGuideGeographicRateComparison") return null;
        var national = tableData.hourlyRateComparisons.national;
        return {
            nationalHourlyRate: roundRate(national.comparison.hourlyRate.amount, numOfDecimalPlaces),
            nationalPercentage: roundRate(national.comparison.percentage.value),
            nationalRelativePosition: constants/* mapCostGuidePercentageRelativePositionToString */.pQ[national.comparison.percentage.relativePosition]
        };
    };
    var getServiceName = function() {
        if (serviceNameLowercase.includes("child care") || serviceNameLowercase.includes("senior care") || serviceNameLowercase.includes("pet care") || serviceNameLowercase.includes("housekeeping") || serviceNameLowercase.includes("house cleaning")) {
            return serviceNamePluralLowercase;
        }
        return "a ".concat(serviceNameLowercase);
    };
    var serviceName = getServiceName();
    var stateGeographicData = getStateGeographicData();
    var nationalGeographicData = getNationalGeographicData();
    var headline = function() {
        if (isGeographicComparison) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "h2",
                mb: 1,
                children: "Here's a comparison of ".concat(serviceNameLowercase, " costs in ").concat(currentCity, ", ").concat(currentStateCode, " to both state and national rates")
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
            variant: "h2",
            mb: 1,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: "These are the "
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    component: "span",
                    color: isMostAffordableCities ? "care.green.700" : "care.red.400",
                    fontWeight: "700",
                    fontSize: "inherit",
                    children: isMostAffordableCities ? "most affordable" : "most expensive"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: " cities for ".concat(serviceNamePluralLowercase, " near ").concat(currentCity, ", ").concat(currentStateCode)
                })
            ]
        });
    };
    var subHeadline = function() {
        if (isGeographicComparison && stateGeographicData && nationalGeographicData) {
            var stateHourlyRate = stateGeographicData.stateHourlyRate, statePercentage = stateGeographicData.statePercentage, stateRelativePosition = stateGeographicData.stateRelativePosition;
            var nationalHourlyRate = nationalGeographicData.nationalHourlyRate, nationalPercentage = nationalGeographicData.nationalPercentage, nationalRelativePosition = nationalGeographicData.nationalRelativePosition;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                variant: isMobileOrSmaller ? "body3" : "body1",
                mb: 2,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "The cost of hiring ".concat(serviceName, " in ").concat(currentCity, ", ").concat(currentStateCode, " is approximately", " ")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        component: "span",
                        fontWeight: "700",
                        fontSize: "inherit",
                        children: "".concat(statePercentage, "% ").concat(stateRelativePosition, " ")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "than ".concat(stateFullName, " average starting rate of $").concat(stateHourlyRate, " per hour and", " ")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        component: "span",
                        fontWeight: "700",
                        fontSize: "inherit",
                        children: "".concat(nationalPercentage, "% ").concat(nationalRelativePosition)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: " than the national average of $".concat(nationalHourlyRate, ".")
                    })
                ]
            });
        }
        if (isMostAffordableCities) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: isMobileOrSmaller ? "body3" : "body1",
                mb: 2,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: "In some cases, nearby cities may offer more affordable ".concat(serviceNameLowercase, " services. When evaluating\n            ").concat(serviceNameLowercase, " pay rates in ").concat(currentCity, ", ").concat(currentStateCode, " and its surrounding areas, it is essential to\n            follow the minimum wage regulations and understand the proper way to pay legally. There\n            are multiple benefits of paying legally that should be considered, such as tax deductions and fostering a professional\n            employment relationship.\n            ")
                })
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
            variant: isMobileOrSmaller ? "body3" : "body1",
            mb: 2,
            children: "You may pay more per hour for ".concat(serviceName, " near ").concat(currentCity, ", ").concat(currentStateCode, " \n        and several factors can contribute to driving up the average rates. They include: higher cost of living, increased demand for ").concat(serviceNameLowercase, " services, a more competitive job market, and specific details surrounding your care needs (i.e. tasks, timeframe, frequency).\n         As a result, it's important to consider these local factors when comparing ").concat(serviceNameLowercase, " rates and hiring ").concat(serviceName, " near ").concat(currentCity, ", ").concat(currentStateCode, ".")
        });
    };
    var getLocation = function(location) {
        if (!location) return "United States";
        var city = location.city, state = location.state;
        if (city && state.stateCode) {
            return "".concat(city, ", ").concat(state.stateCode);
        }
        return constants/* mapStateCodeToFullName */.Q5[state.stateCode];
    };
    var tableHeader = function() {
        var headers = [
            locationHeader,
            avgHourlyRateHeader,
            maxHourlyRateHeader
        ].map(function(header) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                sx: {
                    borderBottom: "none",
                    p: 1
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    className: comparisonChartClassName,
                    variant: isMobileOrSmaller ? "info1" : "h3",
                    fontWeight: "700",
                    children: header
                })
            }, header);
        });
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(TableRow/* default */.Z, {
            children: headers
        });
    };
    var tableRowData = function(rowData) {
        var ref, ref1, ref2, ref3, ref4, ref5;
        var location = rowData.location, rates = rowData.rates, costPageUrl = rowData.costPageUrl;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableRow/* default */.Z, {
            sx: {
                "& .MuiTableCell-root": {
                    borderBottom: "none",
                    p: 1,
                    minWidth: {
                        sm: "140px"
                    }
                }
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableCell/* default */.Z, {
                    children: [
                        (location === null || location === void 0 ? void 0 : location.city) && costPageUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                            href: costPageUrl,
                            variant: isMobileOrSmaller ? "body3" : "body2",
                            children: getLocation(location)
                        }),
                        !(location === null || location === void 0 ? void 0 : location.city) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: isMobileOrSmaller ? "body3" : "body2",
                            children: getLocation(location)
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                    children: (rates === null || rates === void 0 ? void 0 : (ref = rates.averageRate) === null || ref === void 0 ? void 0 : (ref1 = ref.averageHourlyRate) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.rate) === null || ref2 === void 0 ? void 0 : ref2.amount) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: isMobileOrSmaller ? "body3" : "body2",
                        children: "$".concat(roundRate(rates.averageRate.averageHourlyRate.rate.amount, numOfDecimalPlaces), "/hr")
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                    children: (rates === null || rates === void 0 ? void 0 : (ref3 = rates.maximumRate) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.maximumHourlyRate) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.rate) === null || ref5 === void 0 ? void 0 : ref5.amount) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: isMobileOrSmaller ? "body3" : "body2",
                        children: "$".concat(roundRate(rates.maximumRate.maximumHourlyRate.rate.amount, numOfDecimalPlaces), "/hr")
                    })
                })
            ]
        }, costPageUrl);
    };
    var tableBodyData = function() {
        if (!tableData) return [];
        return tableData.locationComparisons.map(function(rowData) {
            return tableRowData(rowData);
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        p: {
            xs: 3,
            sm: 5
        },
        children: [
            headline(),
            subHeadline(),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
                elevation: 0,
                className: comparisonChartClassName,
                sx: {
                    border: "none",
                    py: {
                        xs: 2,
                        sm: 4
                    },
                    px: {
                        xs: 2,
                        sm: 6
                    },
                    "&.geographic": {
                        backgroundColor: "background.blue"
                    },
                    "&.most-affordable": {
                        backgroundColor: "background.green"
                    },
                    "&.most-expensive": {
                        backgroundColor: "background.latte"
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                    container: true,
                    item: true,
                    sx: {
                        alignItems: "center",
                        justifyContent: "space-between",
                        flexDirection: {
                            xs: "column",
                            md: "row"
                        }
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            className: comparisonChartClassName,
                            item: true,
                            pb: 3,
                            sx: {
                                "&.geographic": {
                                    md: 6,
                                    width: "auto"
                                },
                                "&.most-affordable, &.most-expensive": {
                                    width: "100%"
                                }
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Table/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableHead/* default */.Z, {
                                        children: tableHeader()
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableBody/* default */.Z, {
                                        children: tableBodyData()
                                    })
                                ]
                            })
                        }),
                        isGeographicComparison && tableData && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            className: comparisonChartClassName,
                            item: true,
                            sx: {
                                "&.geographic": {
                                    md: 6
                                }
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(costGuide_ComparisonChart, {
                                chartData: tableData.locationComparisons
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var costGuide_ComparisonTable = (ComparisonTable);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@care/react-component-lib/dist/components/Divider/Divider.js
var Divider = __webpack_require__(81956);
// EXTERNAL MODULE: ./node_modules/@care/react-component-lib/dist/components/InlineTextField/InlineTextField.js
var InlineTextField = __webpack_require__(99842);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 3 modules
var Button = __webpack_require__(69417);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(11752);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
// EXTERNAL MODULE: ./node_modules/@care/react-icons/dist/Icon24InfoLocation.js
var Icon24InfoLocation = __webpack_require__(59242);
// EXTERNAL MODULE: ./src/utils/formatNumToString.ts
var formatNumToString = __webpack_require__(78542);
;// CONCATENATED MODULE: ./src/components/pages/costGuide/Hero.tsx














var ref = config_default()(), NEXT_PUBLIC_APP_URL = ref.publicRuntimeConfig.NEXT_PUBLIC_APP_URL;
var Hero = function(param) {
    var primaryHeadline = param.primaryHeadline, serviceNameLowercase = param.serviceNameLowercase, enrollmentUrl = param.enrollmentUrl, city = param.city, state = param.state, rateLastUpdatedDate = param.rateLastUpdatedDate, averageRates = param.averageRates, serviceNamePluralLowercase = param.serviceNamePluralLowercase;
    var ref, ref1, ref2, ref3, ref4, ref5;
    var avgHourlyRate = (averageRates === null || averageRates === void 0 ? void 0 : (ref = averageRates.averageHourlyRate) === null || ref === void 0 ? void 0 : (ref1 = ref.rate) === null || ref1 === void 0 ? void 0 : ref1.amount) ? parseFloat(averageRates.averageHourlyRate.rate.amount).toFixed(2) : null;
    var avgWeeklyRate = (averageRates === null || averageRates === void 0 ? void 0 : (ref2 = averageRates.averageWeeklyRate) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.rate) === null || ref3 === void 0 ? void 0 : ref3.amount) ? (0,formatNumToString/* default */.Z)(Math.round(parseFloat(averageRates.averageWeeklyRate.rate.amount))) : null;
    var avgMonthlyRate = (averageRates === null || averageRates === void 0 ? void 0 : (ref4 = averageRates.averageMonthlyRate) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.rate) === null || ref5 === void 0 ? void 0 : ref5.amount) ? (0,formatNumToString/* default */.Z)(Math.round(parseFloat(averageRates.averageMonthlyRate.rate.amount))) : null;
    var zipCodeRegex = /^\d{0,5}$/;
    var isMobileOrSmaller = (0,useMediaQuery/* default */.Z)(function(theme) {
        return theme.breakpoints.down("md");
    });
    var ref6 = (0,react.useState)({
        zipCode: ""
    }), zip = ref6[0], setZip = ref6[1];
    var onZipCodeChange = function(e) {
        var zipCodeVal = e.target.value;
        if (!zipCodeRegex.test(zipCodeVal)) {
            return;
        }
        setZip(function(prevValues) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevValues), {
                zipCode: zipCodeVal
            });
        });
    };
    var enrollmentLink = zip.zipCode ? "".concat(enrollmentUrl, "&zipcode=").concat(zip.zipCode) : "".concat(enrollmentUrl);
    var ctaText = "Join free to get started";
    var handleCtaBtn = function() {
        var amplitudeData = {
            cta_text: ctaText,
            cta_type: "button",
            url: "".concat(NEXT_PUBLIC_APP_URL).concat(enrollmentLink),
            url_path: enrollmentLink
        };
        (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.ctaInteracted */.Sj.ctaInteracted, amplitudeData);
    };
    var handleKeyUp = function(event) {
        if (event.key === "Enter") {
            handleCtaBtn();
            globalThis.location.href = enrollmentLink;
        }
    };
    var useServiceName = function() {
        if (serviceNameLowercase.includes("child care") || serviceNameLowercase.includes("senior care") || serviceNameLowercase.includes("pet care") || serviceNameLowercase.includes("housekeeping") || serviceNameLowercase.includes("house cleaning")) {
            return serviceNamePluralLowercase;
        }
        return "a ".concat(serviceNameLowercase);
    };
    var serviceName = useServiceName();
    var subheadlineIntro = rateLastUpdatedDate ? "As of ".concat(rateLastUpdatedDate) : "According to our latest data";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        maxWidth: "1062px",
        px: {
            xs: 3,
            sm: 5,
            md: 20,
            lg: 0
        },
        py: {
            xs: 2,
            sm: 5,
            md: 7
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
            careVariant: "subtle",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                px: {
                    xs: 4,
                    sm: 6,
                    md: 10,
                    lg: 13
                },
                pt: {
                    xs: 4,
                    md: 7
                },
                pb: 4,
                children: [
                    primaryHeadline && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "h1",
                        dangerouslySetInnerHTML: {
                            __html: sanitize_html_default()(he_default().decode(primaryHeadline))
                        },
                        fontSize: {
                            md: "display3.fontSize"
                        },
                        pb: {
                            md: 2
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        mt: 3,
                        mb: 2,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                            variant: "h2",
                            color: "care.blue.500",
                            fontWeight: "700",
                            fontSize: {
                                xs: "display3.fontSize",
                                md: "display1.fontSize"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "$".concat(avgHourlyRate)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    component: "span",
                                    fontSize: {
                                        xs: "h2.fontSize",
                                        md: "display3.fontSize"
                                    },
                                    fontWeight: "700",
                                    children: "/hour"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                        variant: isMobileOrSmaller ? "body3" : "body1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "".concat(subheadlineIntro, ", the average starting cost of ").concat(serviceName, " in ").concat(city, ", ").concat(state, " is", " ")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                component: "span",
                                fontSize: "inherit",
                                fontWeight: "700",
                                children: "$".concat(avgHourlyRate, " per hour.", " ")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "The weekly rate for ".concat(serviceName, " in ").concat(city, ", ").concat(state, " is $").concat(avgWeeklyRate, " ", "for working a 40-hour week.", " ")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "And the monthly cost is approximately $".concat(avgMonthlyRate, " for 130 hours of work.")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        width: {
                            xs: "90px",
                            md: "180px"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        pb: 2,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: isMobileOrSmaller ? "h4" : "h2",
                            children: "Find ".concat(serviceName, " in your area")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        pb: {
                            xs: 2,
                            sm: 0
                        },
                        display: "flex",
                        flexDirection: {
                            xs: "column",
                            sm: "row"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(InlineTextField/* default */.Z, {
                                autoFocus: !isMobileOrSmaller,
                                id: "zipCode",
                                name: "zipCode",
                                placeholder: "ZIP code",
                                value: zip.zipCode,
                                onKeyUp: handleKeyUp,
                                onChange: onZipCodeChange,
                                InputProps: {
                                    endAdornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon24InfoLocation/* default */.Z, {})
                                },
                                sx: function(theme) {
                                    return (0,_define_property/* default */.Z)({
                                        paddingX: 0,
                                        maxWidth: "279px",
                                        paddingBottom: 2,
                                        // removes number arrows from Chrome, Safari, Edge, Opera
                                        "& input::-webkit-outer-spin-button, input::-webkit-inner-spin-button": {
                                            appearance: "none",
                                            margin: 0
                                        },
                                        // removes number arrows from Firefox
                                        "& input[type=text]": {
                                            cursor: "auto",
                                            padding: theme.spacing(2, 2, 2, 0),
                                            fontSize: theme.typography.body2.fontSize
                                        },
                                        ".MuiInputBase-root": {
                                            paddingTop: 2
                                        },
                                        ".MuiInputBase-adornedEnd svg": {
                                            marginRight: 0,
                                            marginTop: "-5px !important"
                                        }
                                    }, theme.breakpoints.up("sm"), {
                                        paddingRight: 2
                                    });
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                width: {
                                    xs: "279px",
                                    sm: "321px"
                                },
                                pt: {
                                    sm: 0.5
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    color: "primary",
                                    component: "a",
                                    fullWidth: true,
                                    onClick: handleCtaBtn,
                                    href: enrollmentLink,
                                    size: "large",
                                    variant: "contained",
                                    sx: {
                                        fontWeight: "700"
                                    },
                                    rel: "nofollow",
                                    children: ctaText
                                })
                            })
                        ]
                    }),
                    rateLastUpdatedDate && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "info2",
                        pt: 0.5,
                        color: "care.grey.600",
                        fontSize: {
                            md: "info1.fontSize"
                        },
                        children: "Data is based on rates in caregiver and provider profiles on Care.com. Last updated in ".concat(rateLastUpdatedDate, ".")
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var costGuide_Hero = (Hero);

// EXTERNAL MODULE: ./node_modules/@care/react-icons/dist/IconIllustrationSmallCalculator.js
var IconIllustrationSmallCalculator = __webpack_require__(73103);
;// CONCATENATED MODULE: ./src/components/pages/costGuide/CostGuide404.tsx









function CostGuide404(param) {
    var seoSegmentId = param.seoSegmentId, deviceChar = param.deviceChar;
    var segmentInfo = seoSegmentId.split("/");
    var segmentation = segmentInfo[2];
    var city = segmentInfo[3].replace(/-/g, " ").slice(0, -3);
    var stateCode = segmentInfo[3].replace(/-/g, " ").slice(-2);
    (0,react.useEffect)(function() {
        var pageProperties = {
            screen_name: "Cost Guide Page",
            screen_template: constants/* ScreenTemplate.COST_GUIDE */.Yj.COST_GUIDE,
            seo_page_id: 1533
        };
        if (deviceChar && Object.keys(deviceChar).length > 0) {
            (0,analyticsHelper/* setPagePropertiesFromData */.UP)(pageProperties);
            (0,analyticsHelper/* setDeviceDataFromHeaders */.xF)(deviceChar);
        }
        (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.errorViewed */.Sj.errorViewed, {
            error_description: "SEO no results"
        });
    }, [
        deviceChar
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SeoGlobalNavbar/* default */.Z, {
                enrollmentURL: "/app/vhp/get-started"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CostGuideSlimSearch/* default */.Z, {
                expanded: true,
                segmentation: segmentation,
                searchDefaults: undefined
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                container: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        xs: 12,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            gap: 1.25,
                            padding: 9,
                            textAlign: "center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(IconIllustrationSmallCalculator/* default */.Z, {
                                    size: 100
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                    variant: "h2",
                                    color: "textPrimary",
                                    children: [
                                        "Cost data for",
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            component: "span",
                                            textTransform: "capitalize",
                                            fontSize: "inherit",
                                            fontWeight: "inherit",
                                            children: city
                                        }),
                                        ", ",
                                        stateCode === null || stateCode === void 0 ? void 0 : stateCode.toUpperCase(),
                                        " is currently unavailable."
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    variant: "body1",
                                    color: "textPrimary",
                                    children: "Try searching again for the nearest city."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    variant: "body3",
                                    color: "textSecondary",
                                    children: "Error Code: 404"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        xs: 12,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CoreGlobalFooter/* default */.Z, {})
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/pages/costGuide/CostGuidePriceSpecificationSchema.tsx

var CostGuidePriceSpecificationSchema = function(param) {
    var averageHourlyRate = param.averageHourlyRate;
    var avgHourlyRate = parseFloat(averageHourlyRate.rate.amount).toFixed(2);
    var currentDate = new Date();
    var firstDateOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
    var lastDateOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
    var costGuidePriceSpecificationSchema = {
        "@context": "https://schema.org",
        "@type": "PriceSpecification",
        price: "".concat(avgHourlyRate, "/hour"),
        priceCurrency: "USD",
        validFrom: firstDateOfMonth.toISOString(),
        validThrough: lastDateOfMonth.toISOString()
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
        "data-testid": "costGuidePriceSpecificationSchema",
        type: "application/ld+json",
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: JSON.stringify(costGuidePriceSpecificationSchema)
        }
    });
};


;// CONCATENATED MODULE: ./src/components/pages/costGuide/CostGuidePage.tsx
/* eslint-disable complexity */ /* eslint-disable react-hooks/rules-of-hooks */ 




















var CostGuidePage = function(props) {
    var ref, ref1, ref2;
    var deviceChar = props.deviceChar, seoSegmentId = props.seoSegmentId, errors = props.errors;
    var ref3 = (0,useLDClientFlags/* useLDClientFlags */.y)(), GAMFlag = ref3.SEO_3487_GAM_ADS_SEO_MFE;
    var showGAMAds = GAMFlag && GAMFlag.variationIndex === 1;
    var gamRef = (0,react.useRef)(null);
    var ref4 = (0,react.useState)(false), gamIsVisible = ref4[0], setGamIsVisible = ref4[1];
    if (errors) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(CostGuide404, {
            seoSegmentId: seoSegmentId,
            deviceChar: deviceChar
        });
    }
    var _pageData = props.pageData, _costGuide = _pageData.costGuide, category = _costGuide.category, location = _costGuide.location, meta = _costGuide.meta, primaryHeadline = _costGuide.primaryHeadline, _rates = _costGuide.rates, averageRate = _rates.averageRate, lastUpdatedDate = _rates.lastUpdatedDate, searchDefaults = _costGuide.searchDefaults, _searchDefaults = _costGuide.searchDefaults, service = _searchDefaults.service, searchDefaultLocation = _searchDefaults.location, _service = _costGuide.service, czenServiceId = _service.czenServiceId, serviceIdForMemberEnum = _service.serviceIdForMember, _costGuideComparisons = _pageData.costGuideComparisons, geographicRateComparison = _costGuideComparisons.geographicRateComparison, mostAffordableRateComparison = _costGuideComparisons.mostAffordableRateComparison, mostExpensiveRateComparison = _costGuideComparisons.mostExpensiveRateComparison, costGuideLinkSections = _pageData.costGuideLinkSections, costGuideServiceSpecialties = _pageData.costGuideServiceSpecialties;
    var monthYearDate = lastUpdatedDate ? (0,dateMonthYearFormat/* default */.Z)({
        dateTime: lastUpdatedDate,
        useLongMonth: true
    }) : null;
    var ref5;
    var serviceNameLowercase = (ref5 = category === null || category === void 0 ? void 0 : (ref = category.categoryName) === null || ref === void 0 ? void 0 : ref.categoryNameSingularLowerCase) !== null && ref5 !== void 0 ? ref5 : "service";
    var ref6;
    var serviceNamePluralLowercase = (ref6 = category === null || category === void 0 ? void 0 : (ref1 = category.categoryName) === null || ref1 === void 0 ? void 0 : ref1.categoryNamePluralLowerCase) !== null && ref6 !== void 0 ? ref6 : "services";
    var serviceIdForMember = constants/* mapServiceIdToMemberEnumToString */.xN[serviceIdForMemberEnum];
    var serviceId = constants/* mapServiceTypeToCzenServiceId */.Ft[czenServiceId];
    var enrollmentUrl = (0,generateEnrollmentUrl/* default */.Z)({
        serviceIdForMember: serviceIdForMember,
        serviceId: serviceId !== null && serviceId !== void 0 ? serviceId : ""
    });
    var segmentationUrl = searchDefaultLocation ? "/".concat(service.slug, "/").concat(searchDefaultLocation.slug) : "/".concat(service.slug);
    var fallBackTitle = "How much does a ".concat(serviceNameLowercase, " cost in ").concat(location === null || location === void 0 ? void 0 : location.city, ", ").concat(location === null || location === void 0 ? void 0 : location.state.stateCode, "?");
    var fallBackDescription = "Find how much to pay for a ".concat(serviceNameLowercase, " in ").concat(location === null || location === void 0 ? void 0 : location.city, ", ").concat(location === null || location === void 0 ? void 0 : location.state.stateCode, " with latest data from ").concat(monthYearDate, ". ").concat(location === null || location === void 0 ? void 0 : location.city, ", ").concat(location === null || location === void 0 ? void 0 : location.state.stateCode, " ").concat(serviceNameLowercase, " pay rates are based on latest rates reported by providers listed on Care.com.");
    var fallBackCanonicalUrl = "https://www.care.com/cost".concat(segmentationUrl);
    (0,react.useEffect)(function() {
        var pageProperties = {
            screen_name: "Cost Guide Page",
            screen_template: constants/* ScreenTemplate.COST_GUIDE */.Yj.COST_GUIDE,
            seo_page_id: 1533,
            service_id_for_member: serviceIdForMember
        };
        if (deviceChar && Object.keys(deviceChar).length > 0) {
            (0,analyticsHelper/* setPagePropertiesFromData */.UP)(pageProperties);
            (0,analyticsHelper/* setDeviceDataFromHeaders */.xF)(deviceChar);
        }
    }, [
        deviceChar,
        serviceIdForMember
    ]);
    (0,react.useEffect)(function() {
        var amplitudeDataForPageViewed = {
            seo_page_title: primaryHeadline,
            seo_page_type: "Caregiver Page",
            page_template: "Local"
        };
        (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.seoPageViewed */.Sj.seoPageViewed, amplitudeDataForPageViewed);
    }, [
        primaryHeadline
    ]);
    (0,react.useEffect)(function() {
        var observer = new IntersectionObserver(function(param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 1), entry = _param[0];
            if (entry.isIntersecting) {
                setGamIsVisible(true);
                observer.disconnect();
            }
        }, {
            threshold: 0.5
        });
        var currentGamRef = gamRef.current;
        if (currentGamRef) {
            observer.observe(currentGamRef);
        }
        return function() {
            if (currentGamRef) {
                observer.unobserve(currentGamRef);
            }
        };
    }, [
        gamRef
    ]);
    (0,react.useEffect)(function() {
        if (gamIsVisible && GAMFlag && GAMFlag.reason.kind === constants/* LaunchDarklyEvaluationReasons.RULE_MATCH */.Dn.RULE_MATCH) {
            (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.testExposure */.Sj.testExposure, {
                test_name: constants/* UI_FEATURE_FLAGS.SEO_3487_GAM_ADS_SEO_MFE.id */.WV.SEO_3487_GAM_ADS_SEO_MFE.id,
                test_variant: GAMFlag.variationIndex,
                service_id_for_member: serviceIdForMember,
                page_template: "Local"
            });
        }
    }, [
        GAMFlag,
        gamIsVisible,
        serviceIdForMember
    ]);
    var ref7, ref8, ref9, ref10, ref11, _stateCode, ref12, _stateCode1, ref13, _stateCode2, ref14, _stateCode3;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageMeta/* default */.Z, {
                title: (ref7 = meta === null || meta === void 0 ? void 0 : meta.title) !== null && ref7 !== void 0 ? ref7 : fallBackTitle,
                metaDescriptions: (ref8 = meta === null || meta === void 0 ? void 0 : meta.description) !== null && ref8 !== void 0 ? ref8 : fallBackDescription,
                canonicalUrl: (ref9 = meta === null || meta === void 0 ? void 0 : meta.canonicalURL) !== null && ref9 !== void 0 ? ref9 : fallBackCanonicalUrl,
                isCostGuidePage: true
            }),
            (averageRate === null || averageRate === void 0 ? void 0 : averageRate.averageHourlyRate) && /*#__PURE__*/ (0,jsx_runtime.jsx)(CostGuidePriceSpecificationSchema, {
                averageHourlyRate: averageRate.averageHourlyRate
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SeoGlobalNavbar/* default */.Z, {
                enrollmentURL: enrollmentUrl
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CostGuideSlimSearch/* default */.Z, {
                searchDefaults: searchDefaults,
                costGuideServiceSpecialties: costGuideServiceSpecialties
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                container: true,
                item: true,
                xs: 12,
                sx: {
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    backgroundImage: "url(".concat((0,createRelativeImageURL/* default */.Z)(constants/* COST_GUIDE_HERO_BG_IMG_URL */.ET), "?im=)")
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(costGuide_Hero, {
                    city: location === null || location === void 0 ? void 0 : location.city,
                    enrollmentUrl: enrollmentUrl,
                    primaryHeadline: primaryHeadline,
                    rateLastUpdatedDate: monthYearDate,
                    serviceNameLowercase: serviceNameLowercase,
                    state: (ref10 = location === null || location === void 0 ? void 0 : (ref2 = location.state) === null || ref2 === void 0 ? void 0 : ref2.stateCode) !== null && ref10 !== void 0 ? ref10 : null,
                    averageRates: averageRate,
                    serviceNamePluralLowercase: serviceNamePluralLowercase
                })
            }),
            showGAMAds && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                ref: gamRef,
                m: "0 auto",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GAMAds/* GAMAds */.U, {
                    slotName: constants/* HTL_SLOTS.SEO_COST_INLINE_1 */.YQ.SEO_COST_INLINE_1
                })
            }),
            geographicRateComparison && /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                maxWidth: "md",
                disableGutters: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(costGuide_ComparisonTable, {
                    currentCity: (ref11 = location === null || location === void 0 ? void 0 : location.city) !== null && ref11 !== void 0 ? ref11 : null,
                    currentStateCode: (_stateCode = location === null || location === void 0 ? void 0 : location.state.stateCode) !== null && _stateCode !== void 0 ? _stateCode : null,
                    serviceNameLowercase: serviceNameLowercase,
                    serviceNamePluralLowercase: serviceNamePluralLowercase,
                    tableData: geographicRateComparison,
                    isGeographicComparison: true
                }, "geographicRate")
            }),
            mostAffordableRateComparison && /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                maxWidth: "md",
                disableGutters: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(costGuide_ComparisonTable, {
                    currentCity: (ref12 = location === null || location === void 0 ? void 0 : location.city) !== null && ref12 !== void 0 ? ref12 : null,
                    currentStateCode: (_stateCode1 = location === null || location === void 0 ? void 0 : location.state.stateCode) !== null && _stateCode1 !== void 0 ? _stateCode1 : null,
                    serviceNameLowercase: serviceNameLowercase,
                    serviceNamePluralLowercase: serviceNamePluralLowercase,
                    tableData: mostAffordableRateComparison,
                    isMostAffordableCities: true
                }, "mostAffordableRate")
            }),
            showGAMAds && /*#__PURE__*/ (0,jsx_runtime.jsx)(GAMAds/* GAMAds */.U, {
                slotName: constants/* HTL_SLOTS.SEO_COST_INLINE_2 */.YQ.SEO_COST_INLINE_2
            }),
            mostExpensiveRateComparison && /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                maxWidth: "md",
                disableGutters: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(costGuide_ComparisonTable, {
                    currentCity: (ref13 = location === null || location === void 0 ? void 0 : location.city) !== null && ref13 !== void 0 ? ref13 : null,
                    currentStateCode: (_stateCode2 = location === null || location === void 0 ? void 0 : location.state.stateCode) !== null && _stateCode2 !== void 0 ? _stateCode2 : null,
                    serviceNameLowercase: serviceNameLowercase,
                    serviceNamePluralLowercase: serviceNamePluralLowercase,
                    tableData: mostExpensiveRateComparison
                }, "mostExpensiveRate")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                item: true,
                xs: 12,
                sx: {
                    backgroundColor: "care.grey.100"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                    maxWidth: "md",
                    disableGutters: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HowItWorks/* default */.Z, {
                        serviceIdForMember: serviceIdForMember,
                        segmentNamePluralLowerCase: serviceNamePluralLowercase,
                        segmentNameSingularLowerCase: serviceNameLowercase,
                        segmentationUrl: segmentationUrl,
                        isCostGuidePage: true
                    })
                })
            }),
            costGuideLinkSections && /*#__PURE__*/ (0,jsx_runtime.jsx)(costGuide_CostGuideLinkList, {
                costGuideLinkList: costGuideLinkSections,
                city: (ref14 = location === null || location === void 0 ? void 0 : location.city) !== null && ref14 !== void 0 ? ref14 : null,
                stateCode: (_stateCode3 = location === null || location === void 0 ? void 0 : location.state.stateCode) !== null && _stateCode3 !== void 0 ? _stateCode3 : null
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CoreGlobalFooter/* default */.Z, {})
        ]
    });
};
/* harmony default export */ var costGuide_CostGuidePage = (CostGuidePage);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./src/lib/ApolloClient.ts + 75 modules
var ApolloClient = __webpack_require__(77414);
// EXTERNAL MODULE: ./src/utils/getDeviceCharacteristics.ts
var getDeviceCharacteristics = __webpack_require__(93867);
// EXTERNAL MODULE: ./src/utils/reqHeaderToEntriesObj.ts
var reqHeaderToEntriesObj = __webpack_require__(28906);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 12 modules
var lib = __webpack_require__(68806);
// EXTERNAL MODULE: ./src/API/utils.ts
var utils = __webpack_require__(36630);
;// CONCATENATED MODULE: ./src/API/costGuide.ts



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query costGuide($id: ID!) {\n    costGuide(id: $id) {\n      __typename\n      ... on CostGuideSuccess {\n        costGuide {\n          category {\n            categoryName {\n              categoryNamePluralLowerCase\n              categoryNamePluralTitleCase\n              categoryNameSingularLowerCase\n              categoryNameSingularTitleCase\n            }\n          }\n          location {\n            city\n            state {\n              name\n              stateCode\n            }\n          }\n          meta {\n            canonicalURL\n            description\n            title\n          }\n          primaryHeadline\n          rates {\n            averageRate {\n              averageHourlyRate {\n                rate {\n                  amount\n                  currencyCode\n                }\n                rateDuration\n              }\n              averageMonthlyRate {\n                rate {\n                  amount\n                  currencyCode\n                }\n                rateDuration\n              }\n              averageWeeklyRate {\n                rate {\n                  amount\n                  currencyCode\n                }\n                rateDuration\n              }\n            }\n            lastUpdatedDate\n            maximumRate {\n              maximumHourlyRate {\n                rate {\n                  amount\n                  currencyCode\n                }\n                rateDuration\n              }\n              maximumMonthlyRate {\n                rate {\n                  amount\n                  currencyCode\n                }\n                rateDuration\n              }\n              maximumWeeklyRate {\n                rate {\n                  amount\n                  currencyCode\n                }\n                rateDuration\n              }\n            }\n          }\n          searchDefaults {\n            location {\n              location {\n                city\n                state {\n                  name\n                  stateCode\n                }\n              }\n              slug\n            }\n            service {\n              name\n              serviceId\n              slug\n            }\n          }\n          service {\n            czenServiceId\n            serviceIdForMember\n          }\n        }\n      }\n      ... on CostGuideError {\n        errors {\n          message\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var COST_GUIDE = (0,lib/* default */.ZP)(_templateObject());
var costGuide_costGuide = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(client, log, variables) {
        var ref, queryResponse, error, data, errors, responseError;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,utils/* apolloClientQuery */.M)(client, COST_GUIDE, variables)
                    ];
                case 1:
                    ref = _state.sent(), queryResponse = ref.queryResponse, error = ref.error;
                    // unknown error
                    if (error) {
                        return [
                            2,
                            {
                                costGuide: null,
                                error: error
                            }
                        ];
                    }
                    data = queryResponse.data, errors = queryResponse.errors, responseError = queryResponse.error;
                    // GraphQL errors that occur while processing a GraphQL operation (resulting in built-in error codes such as INTERNAL_SERVER_ERROR)
                    if (errors && errors.length > 0) {
                        return [
                            2,
                            {
                                costGuide: null,
                                error: errors
                            }
                        ];
                    }
                    // Coverage for 'error' property in queryResponse
                    if (responseError) {
                        return [
                            2,
                            {
                                costGuide: null,
                                error: responseError
                            }
                        ];
                    }
                    // known error
                    if (data.costGuide.__typename === "CostGuideError") {
                        log.error("[GraphQL errors]: ".concat(errors));
                        return [
                            2,
                            {
                                costGuide: null,
                                error: data.costGuide.errors
                            }
                        ];
                    }
                    return [
                        2,
                        {
                            costGuide: data.costGuide.costGuide,
                            error: null
                        }
                    ];
            }
        });
    });
    return function costGuide(client, log, variables) {
        return _ref.apply(this, arguments);
    };
}();


;// CONCATENATED MODULE: ./src/API/costGuideComparisons.ts



function costGuideComparisons_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query costGuideComparisons($costGuideComparisonsId: ID!) {\n    costGuideComparisons(id: $costGuideComparisonsId) {\n      __typename\n      ... on CostGuideComparisonsSuccess {\n        costGuideComparisons {\n          geographicRateComparison {\n            hourlyRateComparisons {\n              comparedAgainstRate {\n                amount\n                currencyCode\n              }\n              national {\n                comparison {\n                  hourlyRate {\n                    amount\n                    currencyCode\n                  }\n                  percentage {\n                    relativePosition\n                    value\n                  }\n                }\n                country\n              }\n              state {\n                comparison {\n                  hourlyRate {\n                    amount\n                    currencyCode\n                  }\n                  percentage {\n                    relativePosition\n                    value\n                  }\n                }\n                stateCode\n              }\n            }\n            locationComparisons {\n              location {\n                city\n                state {\n                  name\n                  stateCode\n                }\n              }\n              rates {\n                averageRate {\n                  averageHourlyRate {\n                    rate {\n                      amount\n                      currencyCode\n                    }\n                    rateDuration\n                  }\n                  averageMonthlyRate {\n                    rate {\n                      amount\n                      currencyCode\n                    }\n                    rateDuration\n                  }\n                  averageWeeklyRate {\n                    rate {\n                      amount\n                      currencyCode\n                    }\n                    rateDuration\n                  }\n                }\n                lastUpdatedDate\n                maximumRate {\n                  maximumHourlyRate {\n                    rate {\n                      amount\n                      currencyCode\n                    }\n                    rateDuration\n                  }\n                  maximumMonthlyRate {\n                    rate {\n                      amount\n                      currencyCode\n                    }\n                    rateDuration\n                  }\n                  maximumWeeklyRate {\n                    rate {\n                      amount\n                      currencyCode\n                    }\n                    rateDuration\n                  }\n                }\n              }\n              segmentationUrl\n              costPageUrl\n            }\n          }\n          mostAffordableRateComparison {\n            locationComparisons {\n              location {\n                city\n                state {\n                  name\n                  stateCode\n                }\n              }\n              rates {\n                averageRate {\n                  averageHourlyRate {\n                    rate {\n                      amount\n                      currencyCode\n                    }\n                    rateDuration\n                  }\n                  averageMonthlyRate {\n                    rate {\n                      amount\n                      currencyCode\n                    }\n                    rateDuration\n                  }\n                  averageWeeklyRate {\n                    rate {\n                      amount\n                      currencyCode\n                    }\n                    rateDuration\n                  }\n                }\n                lastUpdatedDate\n                maximumRate {\n                  maximumHourlyRate {\n                    rate {\n                      amount\n                      currencyCode\n                    }\n                    rateDuration\n                  }\n                  maximumMonthlyRate {\n                    rate {\n                      amount\n                      currencyCode\n                    }\n                    rateDuration\n                  }\n                  maximumWeeklyRate {\n                    rate {\n                      amount\n                      currencyCode\n                    }\n                    rateDuration\n                  }\n                }\n              }\n              segmentationUrl\n              costPageUrl\n            }\n          }\n          mostExpensiveRateComparison {\n            locationComparisons {\n              location {\n                city\n                state {\n                  name\n                  stateCode\n                }\n              }\n              rates {\n                averageRate {\n                  averageHourlyRate {\n                    rate {\n                      amount\n                      currencyCode\n                    }\n                    rateDuration\n                  }\n                  averageMonthlyRate {\n                    rate {\n                      amount\n                      currencyCode\n                    }\n                    rateDuration\n                  }\n                  averageWeeklyRate {\n                    rate {\n                      amount\n                      currencyCode\n                    }\n                    rateDuration\n                  }\n                }\n                lastUpdatedDate\n                maximumRate {\n                  maximumHourlyRate {\n                    rate {\n                      amount\n                      currencyCode\n                    }\n                    rateDuration\n                  }\n                  maximumMonthlyRate {\n                    rate {\n                      amount\n                      currencyCode\n                    }\n                    rateDuration\n                  }\n                  maximumWeeklyRate {\n                    rate {\n                      amount\n                      currencyCode\n                    }\n                    rateDuration\n                  }\n                }\n              }\n              segmentationUrl\n              costPageUrl\n            }\n          }\n        }\n      }\n      ... on CostGuideComparisonsError {\n        __typename\n        errors {\n          __typename\n          message\n        }\n      }\n    }\n  }\n"
    ]);
    costGuideComparisons_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var COST_GUIDE_COMPARISONS = (0,lib/* default */.ZP)(costGuideComparisons_templateObject());
var costGuideComparisons_costGuideComparisons = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(client, log, variables) {
        var ref, queryResponse, error, data, errors, responseError;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,utils/* apolloClientQuery */.M)(client, COST_GUIDE_COMPARISONS, variables)
                    ];
                case 1:
                    ref = _state.sent(), queryResponse = ref.queryResponse, error = ref.error;
                    // unknown error
                    if (error) {
                        return [
                            2,
                            {
                                costGuideComparisons: null,
                                error: error
                            }
                        ];
                    }
                    data = queryResponse.data, errors = queryResponse.errors, responseError = queryResponse.error;
                    // GraphQL errors that occur while processing a GraphQL operation (resulting in built-in error codes such as INTERNAL_SERVER_ERROR)
                    if (errors && errors.length > 0) {
                        return [
                            2,
                            {
                                costGuideComparisons: null,
                                error: errors
                            }
                        ];
                    }
                    // Coverage for 'error' property in queryResponse
                    if (responseError) {
                        return [
                            2,
                            {
                                costGuideComparisons: null,
                                error: responseError
                            }
                        ];
                    }
                    // known error
                    if (data.costGuideComparisons.__typename === "CostGuideComparisonsError") {
                        log.error("[GraphQL errors]: ".concat(errors));
                        return [
                            2,
                            {
                                costGuideComparisons: null,
                                error: data.costGuideComparisons.errors
                            }
                        ];
                    }
                    return [
                        2,
                        {
                            costGuideComparisons: data.costGuideComparisons.costGuideComparisons,
                            error: null
                        }
                    ];
            }
        });
    });
    return function costGuideComparisons(client, log, variables) {
        return _ref.apply(this, arguments);
    };
}();


;// CONCATENATED MODULE: ./src/API/getSegmentationLinkSections.ts



function getSegmentationLinkSections_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query getSEOSegmentationLinkSections($seoSegmentId: ID!) {\n    getSEOSegmentationLinkSections(seoSegmentId: $seoSegmentId) {\n      id\n      title\n      linkList {\n        content\n        createDate\n        description\n        url\n        imageDetails {\n          imageHeight\n          imageSize\n          imageUrl\n          imageWidth\n        }\n      }\n    }\n  }\n"
    ]);
    getSegmentationLinkSections_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var GET_SEGMENTATION_LINK_SECTIONS = (0,lib/* gql */.Ps)(getSegmentationLinkSections_templateObject());
var getSegmentationLinkSections = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(client, variables) {
        return (0,tslib_es6.__generator)(this, function(_state) {
            return [
                2,
                (0,utils/* apolloClientQuery */.M)(client, GET_SEGMENTATION_LINK_SECTIONS, variables)
            ];
        });
    });
    return function getSegmentationLinkSections(client, variables) {
        return _ref.apply(this, arguments);
    };
}();

// EXTERNAL MODULE: ./src/API/costGuideServiceSpecialties.ts
var costGuideServiceSpecialties = __webpack_require__(81242);
// EXTERNAL MODULE: ./src/types/common.ts
var common = __webpack_require__(49093);
// EXTERNAL MODULE: ./src/utils/GoogleAdsManager/getGAMContentType.ts
var getGAMContentType = __webpack_require__(37424);
// EXTERNAL MODULE: ./src/utils/GoogleAdsManager/getGAMVerticalShortName.ts
var getGAMVerticalShortName = __webpack_require__(28057);
;// CONCATENATED MODULE: ./src/components/pages/costGuide/costGuidePageProps.ts

















var getServerSideProps = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var query, req, res, ref, ref1, ref2, ref3, ref4, ref5, ref6, startPageGSSP, apolloOptions, startApolloClient, apolloClient, stopApolloClient, ref7, serverFeatureFlags, showCostGuideLocalPage, isLocal, userAgent, botInfo, deviceCharHeader, deviceChar, segment, location, seoSegmentId, _careContext, ldClient, ldUser, ldClientFlags, clientFlagPromises, startGetPageData, ref8, costGuideResponse, costGuideComparisonsResponse, costGuideLinkSectionsResponse, stopGetPageData, errors, costGuide, costGuideComparisons, queryResponse, coreVertical, getServiceSpecialties, serviceSpecialties, costGuideLinkSections, _czenServiceId, additionalGAMRules, pageData, pageProps, stopPageGSSP;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    query = param.query, req = param.req, res = param.res;
                    startPageGSSP = performance.now();
                    apolloOptions = {
                        logError: req.log.error.bind(req.log),
                        logInfo: req.log.info.bind(req.log)
                    };
                    startApolloClient = performance.now();
                    apolloClient = (0,ApolloClient/* getApolloClient */.W)(apolloOptions);
                    stopApolloClient = performance.now();
                    serverFeatureFlags = (ref7 = (ref = req.careContext) === null || ref === void 0 ? void 0 : ref.ldServerFlags) !== null && ref7 !== void 0 ? ref7 : false;
                    showCostGuideLocalPage = serverFeatureFlags && ((ref1 = serverFeatureFlags[constants/* SERVER_FEATURE_FLAGS.COST_GUIDE_LOCAL_PAGE */.VL.COST_GUIDE_LOCAL_PAGE]) === null || ref1 === void 0 ? void 0 : ref1.variationIndex) === 1;
                    isLocal = "production" === "development";
                    userAgent = req.headers["user-agent"] || "";
                    botInfo = ((ref2 = req.headers["Akamai-Bot"]) === null || ref2 === void 0 ? void 0 : ref2.toString()) || "";
                    deviceCharHeader = ((ref3 = req.headers["x-akamai-device-characteristics"]) === null || ref3 === void 0 ? void 0 : ref3.toString()) || "";
                    deviceChar = isLocal ? (0,getDeviceCharacteristics/* default */.Z)(userAgent, deviceCharHeader) : (0,reqHeaderToEntriesObj/* default */.Z)(deviceCharHeader, ";");
                    segment = query.segment, location = query.location;
                    seoSegmentId = "/cost/".concat(segment, "/").concat(location);
                    _careContext = req.careContext, ldClient = _careContext.ldClient, ldUser = _careContext.ldUser;
                    ldClientFlags = {};
                    if (!(ldClient && ldUser)) return [
                        3,
                        2
                    ];
                    ldUser.custom = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, ldUser.custom), {
                        seoSegmentId: seoSegmentId,
                        pageTemplate: common/* PageTemplate.COST_GUIDE */.P.COST_GUIDE
                    });
                    clientFlagPromises = Object.values(constants/* UI_FEATURE_FLAGS */.WV).map(function() {
                        var _ref = (0,_async_to_generator/* default */.Z)(function(flag) {
                            var _;
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _ = flag.id;
                                        return [
                                            4,
                                            ldClient.variationDetail(flag.id, ldUser, undefined)
                                        ];
                                    case 1:
                                        ldClientFlags[_] = _state.sent();
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                        return function(flag) {
                            return _ref.apply(this, arguments);
                        };
                    }());
                    return [
                        4,
                        Promise.all(clientFlagPromises)
                    ];
                case 1:
                    _state.sent();
                    _state.label = 2;
                case 2:
                    startGetPageData = performance.now();
                    return [
                        4,
                        Promise.all([
                            costGuide_costGuide(apolloClient, req.log, {
                                id: seoSegmentId
                            }),
                            costGuideComparisons_costGuideComparisons(apolloClient, req.log, {
                                costGuideComparisonsId: seoSegmentId
                            }),
                            getSegmentationLinkSections(apolloClient, {
                                seoSegmentId: seoSegmentId
                            })
                        ])
                    ];
                case 3:
                    ref8 = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                        _state.sent(),
                        3
                    ]), costGuideResponse = ref8[0], costGuideComparisonsResponse = ref8[1], costGuideLinkSectionsResponse = ref8[2];
                    stopGetPageData = performance.now();
                    if (costGuideResponse.error || costGuideComparisonsResponse.error) {
                        errors = {
                            costGuideErrors: costGuideResponse.error,
                            costGuideComparisonsErrors: costGuideComparisonsResponse.error
                        };
                        req.log.error({
                            event: "costGuidePageLoadError",
                            seoSegmentId: seoSegmentId,
                            userAgent: userAgent,
                            deviceChar: deviceChar,
                            query: query,
                            res: res,
                            errors: errors
                        });
                        res.statusCode = 404;
                        return [
                            2,
                            {
                                props: {
                                    errors: errors,
                                    seoSegmentId: seoSegmentId,
                                    deviceChar: deviceChar,
                                    ldClientFlags: ldClientFlags,
                                    additionalGAMRules: {
                                        vertical: "none",
                                        contType: "none"
                                    }
                                }
                            }
                        ];
                    }
                    if (!showCostGuideLocalPage) {
                        return [
                            2,
                            {
                                notFound: true
                            }
                        ];
                    }
                    costGuide = costGuideResponse.costGuide;
                    costGuideComparisons = costGuideComparisonsResponse.costGuideComparisons;
                    queryResponse = costGuideLinkSectionsResponse.queryResponse;
                    coreVertical = (costGuide === null || costGuide === void 0 ? void 0 : (ref4 = costGuide.searchDefaults) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.service) === null || ref5 === void 0 ? void 0 : ref5.serviceId) ? Object.keys(CostGuideSlimSearch/* costGuideVerticalOptions */.a).find(function(key) {
                        return key === costGuide.searchDefaults.service.serviceId;
                    }) : "";
                    getServiceSpecialties = function() {
                        var _ref = (0,_async_to_generator/* default */.Z)(function() {
                            var ref, _serviceSpecialties, serviceSpecialties;
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        if (!coreVertical) return [
                                            3,
                                            2
                                        ];
                                        return [
                                            4,
                                            (0,costGuideServiceSpecialties/* costGuideServiceSpecialtiesQuery */.a)(apolloClient, req.log, {
                                                serviceId: coreVertical ? constants/* ServiceIdForMember */.u2[coreVertical] : ""
                                            })
                                        ];
                                    case 1:
                                        ref = _state.sent(), _serviceSpecialties = ref.serviceSpecialties, serviceSpecialties = _serviceSpecialties === void 0 ? [] : _serviceSpecialties;
                                        return [
                                            2,
                                            serviceSpecialties
                                        ];
                                    case 2:
                                        return [
                                            2,
                                            []
                                        ];
                                }
                            });
                        });
                        return function getServiceSpecialties() {
                            return _ref.apply(this, arguments);
                        };
                    }();
                    return [
                        4,
                        getServiceSpecialties()
                    ];
                case 4:
                    serviceSpecialties = _state.sent();
                    costGuideLinkSections = queryResponse === null || queryResponse === void 0 ? void 0 : (ref6 = queryResponse.data) === null || ref6 === void 0 ? void 0 : ref6.getSEOSegmentationLinkSections;
                    additionalGAMRules = {
                        vertical: (0,getGAMVerticalShortName/* getGAMVerticalShortName */.W)((_czenServiceId = costGuide === null || costGuide === void 0 ? void 0 : costGuide.service.czenServiceId) !== null && _czenServiceId !== void 0 ? _czenServiceId : "none"),
                        contType: (0,getGAMContentType/* getGAMContentType */.P)({
                            pageTemplate: common/* PageTemplate.COST_GUIDE */.P.COST_GUIDE
                        })
                    };
                    pageData = {
                        costGuide: costGuide,
                        costGuideComparisons: costGuideComparisons,
                        costGuideLinkSections: costGuideLinkSections,
                        costGuideServiceSpecialties: serviceSpecialties
                    };
                    pageProps = {
                        props: {
                            pageData: pageData,
                            seoSegmentId: seoSegmentId,
                            deviceChar: deviceChar,
                            ldClientFlags: ldClientFlags,
                            additionalGAMRules: additionalGAMRules
                        }
                    };
                    req.log.info({
                        event: "costGuidePageLoadSuccess",
                        seoSegmentId: seoSegmentId,
                        userAgent: userAgent,
                        deviceChar: deviceChar,
                        query: query,
                        res: res,
                        botInfo: botInfo
                    });
                    stopPageGSSP = performance.now();
                    req.careContext.serverTimings.pageGSSP = stopPageGSSP - startPageGSSP;
                    req.careContext.serverTimings.apolloClient = stopApolloClient - startApolloClient;
                    req.careContext.serverTimings.pageData = stopGetPageData - startGetPageData;
                    return [
                        2,
                        pageProps
                    ];
            }
        });
    });
    return function getServerSideProps(_) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./src/components/pages/costGuide/index.ts



;// CONCATENATED MODULE: ./src/pages/cost/[segment]/[location].tsx
var __N_SSP = true;



/***/ }),

/***/ 37424:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ getGAMContentType; }
/* harmony export */ });
/* harmony import */ var _generated_globalTypes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79967);
/* harmony import */ var _types_common__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49093);


/*
 * This function returns the GAM content type based on the page template and/or searchingFor value.
 *
 * @param searchingFor - The searchingFor value from SEOSegmentationSearchingFor
 * @param pageTemplate - The page template value from PageTemplate
 * @returns The GAM content type.
 */ var getGAMContentType = function(param) {
    var searchingFor = param.searchingFor, pageTemplate = param.pageTemplate;
    if (pageTemplate === _types_common__WEBPACK_IMPORTED_MODULE_1__/* .PageTemplate.COST_GUIDE */ .P.COST_GUIDE) {
        return "none";
    }
    if (searchingFor === _generated_globalTypes__WEBPACK_IMPORTED_MODULE_0__/* .SEOSegmentationSearchingFor.ALL_JOB */ .yh.ALL_JOB || searchingFor === _generated_globalTypes__WEBPACK_IMPORTED_MODULE_0__/* .SEOSegmentationSearchingFor.SEEKER_JOB */ .yh.SEEKER_JOB || searchingFor === _generated_globalTypes__WEBPACK_IMPORTED_MODULE_0__/* .SEOSegmentationSearchingFor.SMB_JOB */ .yh.SMB_JOB) {
        return "seeker";
    }
    return "provider";
};



/***/ }),

/***/ 28057:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ getGAMVerticalShortName; }
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42660);
/* harmony import */ var _generated_globalTypes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79967);


var getGAMVerticalShortName = function(serviceId) {
    if (serviceId === _constants__WEBPACK_IMPORTED_MODULE_0__/* .ServiceId.CAREGIGSX */ .Xs.CAREGIGSX || serviceId === _generated_globalTypes__WEBPACK_IMPORTED_MODULE_1__/* .ServiceType.CARE_GIGS */ .UW.CARE_GIGS) {
        return "cg";
    }
    if (serviceId === _constants__WEBPACK_IMPORTED_MODULE_0__/* .ServiceId.PETCAREXX */ .Xs.PETCAREXX || serviceId === _generated_globalTypes__WEBPACK_IMPORTED_MODULE_1__/* .ServiceType.PET_CARE */ .UW.PET_CARE) {
        return "pc";
    }
    if (serviceId === _constants__WEBPACK_IMPORTED_MODULE_0__/* .ServiceId.SENIRCARE */ .Xs.SENIRCARE || serviceId === _generated_globalTypes__WEBPACK_IMPORTED_MODULE_1__/* .ServiceType.SENIOR_CARE */ .UW.SENIOR_CARE) {
        return "sc";
    }
    if (serviceId === _constants__WEBPACK_IMPORTED_MODULE_0__/* .ServiceId.TUTORINGX */ .Xs.TUTORINGX || serviceId === _generated_globalTypes__WEBPACK_IMPORTED_MODULE_1__/* .ServiceType.TUTORING */ .UW.TUTORING) {
        return "tu";
    }
    if (serviceId === _constants__WEBPACK_IMPORTED_MODULE_0__/* .ServiceId.HOUSEKEEP */ .Xs.HOUSEKEEP || serviceId === _generated_globalTypes__WEBPACK_IMPORTED_MODULE_1__/* .ServiceType.HOUSEKEEPING */ .UW.HOUSEKEEPING) {
        return "hk";
    }
    if (serviceId === _constants__WEBPACK_IMPORTED_MODULE_0__/* .ServiceId.CHILDCARE */ .Xs.CHILDCARE || serviceId === _generated_globalTypes__WEBPACK_IMPORTED_MODULE_1__/* .ServiceType.CHILD_CARE */ .UW.CHILD_CARE) {
        return "cc";
    }
    return "none";
};



/***/ }),

/***/ 42182:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/*
 * date conversion to one of the following example formats:
 * Apr 2023
 * April 2023
 * Apr 25, 2023
 * April 25, 2023
 * Apr 25th, 2023
 * April 25th, 2023
 */ // Add postfix like 3rd, 4th, 22nd to the date
var getOrdinalNum = function(n) {
    return n + (n > 0 ? [
        "th",
        "st",
        "nd",
        "rd"
    ][n > 3 && n < 21 || n % 10 > 3 ? 0 : n % 10] : "");
};
var dateMonthYearFormat = function(param) {
    var dateTime = param.dateTime, _useLongMonth = param.useLongMonth, useLongMonth = _useLongMonth === void 0 ? false : _useLongMonth, _useOrdinalDay = param.useOrdinalDay, useOrdinalDay = _useOrdinalDay === void 0 ? false : _useOrdinalDay, _useFullDate = param.useFullDate, useFullDate = _useFullDate === void 0 ? false : _useFullDate;
    var date = new Date(dateTime);
    var dayOftheMonth = useOrdinalDay ? "".concat(getOrdinalNum(date.getUTCDate())) : date.getUTCDate();
    var month = useLongMonth ? date.toLocaleString("en-US", {
        month: "long"
    }) : date.toLocaleString("en-US", {
        month: "short"
    });
    var year = date.getUTCFullYear();
    return useFullDate ? "".concat(month, " ").concat(dayOftheMonth, ", ").concat(year) : "".concat(month, " ").concat(year);
};
/* harmony default export */ __webpack_exports__["Z"] = (dateMonthYearFormat);


/***/ }),

/***/ 78542:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/*
 * Regex to convert numbers into comma separated format(ex. 45200 -> 45,200)
 */ var formatNumToString = function(value) {
    if (Number.isNaN(value) || value === null) return "";
    return value.toLocaleString("en-US");
};
/* harmony default export */ __webpack_exports__["Z"] = (formatNumToString);


/***/ }),

/***/ 85715:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ utils_generateEnrollmentUrl; }
});

;// CONCATENATED MODULE: ./src/utils/getServerSidePropsUtil.ts
// Write tests for these and use them in getServerSideProps
var getSegmentUrl = function(query) {
    var ref;
    var segmentURL = (ref = query.segment) === null || ref === void 0 ? void 0 : ref.toString();
    var ref1;
    var pageStringArr = (ref1 = segmentURL === null || segmentURL === void 0 ? void 0 : segmentURL.split("-page")) !== null && ref1 !== void 0 ? ref1 : ""; // remove anything after -page
    return "/".concat(pageStringArr[0]);
};
var getVerticalUrl = function(query) {
    var ref;
    var verticalURL = (ref = query.vertical) === null || ref === void 0 ? void 0 : ref.toString();
    return "".concat(verticalURL);
};
var getPageNumber = function(query) {
    var ref;
    var segmentURL = ((ref = query.segment) === null || ref === void 0 ? void 0 : ref.toString()) || "";
    var page = 1;
    var urlPageNumber = segmentURL === null || segmentURL === void 0 ? void 0 : segmentURL.replace(/^\D+/g, ""); // find number
    if (urlPageNumber.length > 0) {
        page = Number(urlPageNumber);
    }
    return page;
};

// EXTERNAL MODULE: ./src/constants.ts
var constants = __webpack_require__(42660);
;// CONCATENATED MODULE: ./src/utils/generateEnrollmentUrl.ts


var generateEnrollmentUrl = function(param) {
    var router = param.router, serviceIdForMember = param.serviceIdForMember, tmp = param.serviceId, argServiceId = tmp === void 0 ? "" : tmp, _serviceShortName = param.serviceShortName, serviceShortName = _serviceShortName === void 0 ? "" : _serviceShortName, serviceProfileId = param.serviceProfileId, _directoryFirstExperience = param.directoryFirstExperience, directoryFirstExperience = _directoryFirstExperience === void 0 ? false : _directoryFirstExperience;
    var serviceId = argServiceId !== "" ? argServiceId : constants/* SEO_SERVICE_SHORT_NAMES */.Mk[serviceShortName];
    var serviceDetails = constants/* SEO_SERVICE_DETAILS */.Jm[serviceId];
    var fromSeoPage = "fromSeoPage=".concat(constants/* COMMON_SEO_ENROLLMENT_PARAMS.fromSeoPage */.BC.fromSeoPage);
    var serviceIdParam = "serviceId=".concat(serviceId);
    var memberServiceId = serviceIdForMember !== null && serviceIdForMember !== void 0 ? serviceIdForMember : constants/* SEO_SERVICE_DETAILS */.Jm[serviceId].serviceIdForMemberVal;
    var segmentUrl = (router === null || router === void 0 ? void 0 : router.query.segment) ? getSegmentUrl(router.query) : "";
    if (memberServiceId === memberServiceId.toUpperCase()) {
        memberServiceId = memberServiceId.toLowerCase();
    }
    var adultCareSegments = [
        "/adult-care",
        "/special-needs-adult-care",
        "/post-surgery-care"
    ];
    if (serviceIdForMember === "childCareLocation") {
        memberServiceId = "dayCare";
    } else if (adultCareSegments.includes(segmentUrl)) {
        memberServiceId = "adultCare";
    }
    var serviceIdForMemberParam = "serviceIdForMember=".concat(memberServiceId);
    var source = "source=".concat(constants/* COMMON_SEO_ENROLLMENT_PARAMS.source */.BC.source);
    var pageSource = "pageSource=".concat(serviceDetails.pageSource);
    var visitedServiceProfileId = serviceProfileId ? "&visitedServiceProfileId=".concat(serviceProfileId) : "";
    var enrollmentQueryParams = "".concat(fromSeoPage, "&").concat(serviceIdParam, "&").concat(serviceIdForMemberParam, "&").concat(source, "&").concat(pageSource).concat(visitedServiceProfileId);
    var enrollmentType = memberServiceId.slice(memberServiceId.length - 3) === "Job" ? "provider" : "seeker";
    if (serviceIdForMember === constants/* ServiceIdForMember.CARE_GIGS */.u2.CARE_GIGS) {
        return "/app/vhp/care-kind?".concat(enrollmentQueryParams);
    }
    if (directoryFirstExperience && serviceIdForMember === constants/* ServiceIdForMember.CHILD_CARE_LOCATION */.u2.CHILD_CARE_LOCATION) {
        return "/app/business-search?".concat(enrollmentQueryParams);
    }
    if (serviceIdForMember === constants/* ServiceIdForMember.SPECIAL_NEEDS */.u2.SPECIAL_NEEDS) {
        return "/app/enrollment/".concat(enrollmentType, "/cc?").concat(enrollmentQueryParams);
    }
    // careGigsJob and specialNeedsJob to vertical-triage enrollment flow since they dont have a dedicated flow.
    // The multi-vertical flow will be used on "/jobs, /full-time-jobs, and /part-time-jobs" segmentation pages (these are under childCareJobs):
    if (serviceIdForMember === constants/* ServiceIdForMember.CARE_GIGS_JOB */.u2.CARE_GIGS_JOB || serviceIdForMember === constants/* ServiceIdForMember.SPECIAL_NEEDS_JOB */.u2.SPECIAL_NEEDS_JOB || segmentUrl === "/jobs" || segmentUrl === "/full-time-jobs" || segmentUrl === "/part-time-jobs") {
        return "/app/vhp/vertical-triage?memberType=sitter&".concat(enrollmentQueryParams);
    }
    // Job search enrollment URL
    if (enrollmentType === "provider") {
        return "/app/enrollment/provider/mv/".concat(serviceId, "?").concat(enrollmentQueryParams);
    }
    if (serviceId === constants/* ServiceId.SENIRCARE */.Xs.SENIRCARE && serviceIdForMember === constants/* ServiceIdForMember.HOUSING_LOCATION */.u2.HOUSING_LOCATION) {
        // This is specific to Senior Assisted Living Communities( In facility care or OOH)
        return "/app/enrollment/".concat(enrollmentType, "/").concat(serviceDetails.shortName, "/").concat(constants/* SC_SEEKER_IN_FACILITY_ROUTES.WHO_NEEDS_CARE */.oF.WHO_NEEDS_CARE, "?").concat(enrollmentQueryParams);
    }
    return "/app/enrollment/".concat(enrollmentType, "/").concat(serviceDetails.shortName, "?").concat(enrollmentQueryParams);
};
/* harmony default export */ var utils_generateEnrollmentUrl = (generateEnrollmentUrl);


/***/ }),

/***/ 93867:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _reqHeaderToEntriesObj__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28906);

var getDeviceCharacteristics = function(userAgent, deviceCharHeader) {
    var deviceChar = (0,_reqHeaderToEntriesObj__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(deviceCharHeader, ";");
    if (Object.keys(deviceChar).length === 0) {
        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent)) {
            deviceChar = {
                is_mobile: "true"
            };
        } else {
            deviceChar = {
                is_mobile: "false"
            };
        }
    }
    return deviceChar;
};
/* harmony default export */ __webpack_exports__["Z"] = (getDeviceCharacteristics);


/***/ }),

/***/ 28906:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(828);
/**
 * Transmutes a key/value pairs object into the format expected by GraphQLEnumType
 * @param  {string} header header string of keys and values
 * @param  {string} delimeter symbol used to separate each key value pair from the next pair
 * @param  {string} valueDelimeter symbol used to separate the key from its value within each pair
 * @return {Object}     Entries object (key/value pairs)
 */ 
var reqHeaderToEntriesObj = function(header) {
    var delimiter = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ";", valueDelimeter = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "=";
    if (header === "") return {};
    return header.split(delimiter).reduce(function(accum, curVal) {
        var obj = accum;
        var keyValuePair = curVal.split(valueDelimeter);
        var _keyValuePair = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(keyValuePair, 2), keyValuePairKey = _keyValuePair[0], keyValuePairValue = _keyValuePair[1];
        obj[keyValuePairKey] = keyValuePairValue;
        return obj;
    }, {});
};
/* harmony default export */ __webpack_exports__["Z"] = (reqHeaderToEntriesObj);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2453,898,9417,1207,1136,1767,1036,1903,9635,2494,6492,8396,4858,4383,6925,2839,6610,6745,4417,1600,2690,9774,2888,179], function() { return __webpack_exec__(53002); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);